export const CalloutAdExtension = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'CalloutAdExtension',
    },
  },
};
